import { ShaderCompileDefineBase } from "../../webgl/utils/ShaderCompileDefineBase";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../layagl/LayaGL";
export class ShaderPass extends ShaderCompileDefineBase {
    get pipelineMode() {
        return this._pipelineMode;
    }
    set pipelineMode(value) {
        this._pipelineMode = value;
        this.moduleData.pipelineMode = value;
    }
    set nodeCommonMap(value) {
        this.moduleData.nodeCommonMap = value;
    }
    get nodeCommonMap() {
        return this.moduleData.nodeCommonMap;
    }
    set additionShaderData(value) {
        this.moduleData.additionShaderData = value;
    }
    get additionShaderData() {
        return this.moduleData.additionShaderData;
    }
    get statefirst() {
        return this._statefirst;
    }
    set statefirst(value) {
        this._statefirst = value;
        this.moduleData.statefirst = value;
    }
    get attributeLocations() {
        return this.moduleData.attributeLocations;
    }
    set attributeLocations(value) {
        this.moduleData.attributeLocations = value;
    }
    get renderState() {
        return this.moduleData.renderState;
    }
    constructor(owner, compiledObj) {
        super(owner, owner._owner.name, compiledObj);
        this._statefirst = false;
        this.moduleData = LayaGL.unitRenderModuleDataFactory.createShaderPass(this);
        this.moduleData.validDefine = this._validDefine;
        this.moduleData.name = this.name;
    }
    static createShaderInstance(shaderpass, is2D, compileDefine) {
        _defineStrings.length = 0;
        Shader3D._getNamesByDefineData(compileDefine, _defineStrings);
        let shaderProcessInfo = {
            is2D,
            vs: shaderpass._VS,
            ps: shaderpass._PS,
            attributeMap: shaderpass._owner._attributeMap,
            uniformMap: shaderpass._owner._uniformMap,
            defineString: _defineStrings,
        };
        let shader = LayaGL.renderDeviceFactory.createShaderInstance(shaderProcessInfo, shaderpass);
        return shader;
    }
    withCompile(compileDefine, is2D = false) {
        var shader = this.moduleData.getCacheShader(compileDefine);
        if (shader)
            return shader;
        shader = ShaderPass.createShaderInstance(this, is2D, compileDefine);
        this.moduleData.setCacheShader(compileDefine, shader);
        return shader;
    }
    withComplieByBin(compileDefine, is2D = false, buffer) {
        var shader = this.moduleData.getCacheShader(compileDefine);
        if (shader)
            return shader;
        this.moduleData.setCacheShader(compileDefine, shader);
        return null;
    }
}
const _defineStrings = [];
